var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOthersPlace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000003756"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000003755"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.20786 10.6603C6.46095 11.0871 6 11.8814 6 12.7417V26.7791L11.5516 29.9514L13.4802 31.0535L14.4445 31.6045L17.4579 33.3264L19.5 34.4934L31.7921 27.4693C32.539 27.0425 33 26.2482 33 25.3879V12.7417C33 11.8814 32.5391 11.0871 31.7921 10.6603L20.6893 4.31585C19.9524 3.89472 19.0476 3.89472 18.3107 4.31585L7.20786 10.6603Z",
    fill: "#E7E7E7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000003754"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 33",
    d: "M9.85718 23.7181V14.4114C9.85718 13.7089 10.2258 13.0579 10.8282 12.6965L18.471 8.11074C19.1044 7.73072 19.8957 7.73072 20.529 8.11074L28.1719 12.6965C28.7743 13.0579 29.1429 13.7089 29.1429 14.4114V23.7181C29.1429 24.4206 28.7743 25.0716 28.1719 25.4331L20.529 30.0188C19.8957 30.3988 19.1044 30.3988 18.471 30.0188L10.8282 25.4331C10.2258 25.0716 9.85718 24.4206 9.85718 23.7181Z",
    fill: "url(#paint0_linear_4613_26882)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.6838 21.519V22.3643H21.6961V23.1841H16.8666V22.3643H18.8789V21.519C18.1008 21.4191 17.3853 21.0334 16.8666 20.4343C16.3479 19.8352 16.0617 19.0639 16.0616 18.2651V15.8056H22.501V18.2651C22.501 19.0639 22.2148 19.8352 21.6961 20.4343C21.1774 21.0334 20.4619 21.4191 19.6838 21.519ZM16.8666 16.6254V18.2651C16.8666 18.9174 17.121 19.543 17.5738 20.0042C18.0267 20.4655 18.6409 20.7246 19.2813 20.7246C19.9218 20.7246 20.536 20.4655 20.9889 20.0042C21.4417 19.543 21.6961 18.9174 21.6961 18.2651V16.6254H16.8666ZM14.8542 16.6254H15.6592V18.2651H14.8542V16.6254ZM22.9035 16.6254H23.7084V18.2651H22.9035V16.6254Z",
    fill: "#595959"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4613_26882",
    x1: 27.6029,
    y1: 11.1973,
    x2: 12.4808,
    y2: 26.3194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.989583,
    stopColor: "#9AADA7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOthersPlace);
export default __webpack_public_path__ + "static/media/others-place.67cea0e98350847de1ad62aae6ee63be.svg";
export { ForwardRef as ReactComponent };